import { OrganisationControllerApiFactory } from '@api-client/api'
import { QueryKey } from '@helpers/enums'
import { useQuery } from '@tanstack/react-query'

import { useAsyncApi } from './useAsyncApi'

const useOwnOrganisation = () => {
	const organisationControllerApi = useAsyncApi(
		OrganisationControllerApiFactory
	)
	return useQuery({
		queryKey: [QueryKey.GetOwnOrganisation],
		queryFn: () => organisationControllerApi(api => api.getOwnOrganisation()),
	})
}

export { useOwnOrganisation }
